import { useEffect, useState } from 'react';
import useDebounce from './debounce';
// import useDebounce from '@/hooks/debounce';

export default function useScrollOver(props: { targetHeight?: number }) {
  const { targetHeight = 48 } = props;
  const [isScrollOver, setIsScrollOver] = useState(false);
  const handleScroll = useDebounce(() => {
    //获取滚动的距离
    const scrollDistance = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollDistance > targetHeight) {
      setIsScrollOver(true);
    } else {
      setIsScrollOver(false);
    }
  }, 20);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      setIsScrollOver(false);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return {
    isScrollOver
  };
}
